<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import customerWechatQr from '@/apps/portal/assets/admin-wechat-qr.jpg'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])
const { t } = useI18n()

const visible = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value)
})
</script>

<template>
  <el-dialog
    v-model="visible"
    class="payment-unavailable-dialog"
    :title="t('paymentUnavailable.title')"
    width="min(88vw, 380px)"
    append-to-body
    destroy-on-close
  >
    <div class="payment-unavailable-content">
      <img :src="customerWechatQr" :alt="t('common.adminWechatQrAlt')">
      <p>{{ t('paymentUnavailable.message') }}</p>
    </div>
  </el-dialog>
</template>

<style scoped>
.payment-unavailable-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}

.payment-unavailable-content img {
  display: block;
  width: min(100%, 300px);
  height: auto;
  border-radius: 8px;
}

.payment-unavailable-content p {
  margin: 0;
  color: var(--el-text-color-primary);
  font-size: 15px;
  line-height: 1.6;
}
</style>
